import {
  ApiCartAddProductsToCartRequestedAction,
  apiCartAddProductsToCartFailed,
  apiCartAddProductsToCartSucceeded
} from '@spa/lib/store/api/cart/addProductsToCartApi';
import addProductsToCartAction, {
  AddProductsToCartActionResult
} from '@spa/lib/actions/cart/addProductsToCartAction';
import { call, put } from 'typed-redux-saga';
import { AddToCurrentCartFailedError } from '../../../carts/CartsState';
import createServerTokenSessionSyncAction from '../../../session/createServerTokenSessionSyncAction';

function* addProductsToCartSaga({
  payload: {
    actionId: requestedActionId,
    customOrderType,
    parentActionId,
    productCodesWithQuantities
  }
}: ApiCartAddProductsToCartRequestedAction): Generator {
  try {
    const actionResult: AddProductsToCartActionResult = yield* call(
      addProductsToCartAction,
      'addProductsToCartAction',
      {
        customOrderType,
        productCodesWithQuantities
      }
    );

    if (actionResult.outcome === 'succeeded') {
      const newTokens = actionResult.result.newTokens;
      if (newTokens !== null) {
        yield* put(createServerTokenSessionSyncAction(newTokens));
      }
      yield* put(
        apiCartAddProductsToCartSucceeded({
          cartId: actionResult.result.cart.code,
          parentActionId,
          requestedActionId,
          result: actionResult.result,
          sourceCustomOrderType: actionResult.sourceCustomOrderType,
          targetCustomOrderType: actionResult.targetCustomOrderType
        })
      );
    } else {
      yield* put(
        apiCartAddProductsToCartFailed({
          parentActionId,
          requestedActionId,
          failedReason: actionResult.failedReason
        })
      );
    }
  } catch {
    yield* put(
      apiCartAddProductsToCartFailed({
        parentActionId,
        requestedActionId,
        failedReason: AddToCurrentCartFailedError.UNKNOWN
      })
    );
  }
}

export default addProductsToCartSaga;
